import { render } from "./OwnPage.vue?vue&type=template&id=b2cdd714&scoped=true"
import script from "./OwnPage.vue?vue&type=script&lang=js"
export * from "./OwnPage.vue?vue&type=script&lang=js"

import "./OwnPage.vue?vue&type=style&index=0&id=b2cdd714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2cdd714"]])

export default __exports__